import { CmsRegistrationConfirmationPage } from '../../models/registration-confirmation/cms-registration-confirmation-page.type';
import { mockCmsRegistrationRoot } from '../cms/cms-registration-root.mock';
import { mockCmsRegistrationConfirmationPageHeader } from './cms-registration-confirmation-page-header.mock';

export const mockCmsRegistrationConfirmationPage: CmsRegistrationConfirmationPage =
  {
    ...mockCmsRegistrationRoot,
    ...mockCmsRegistrationConfirmationPageHeader,
  };
